import { Box } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { taskV2 } from '@fireflyhealth/api'
import { useMutation, useQuery } from '~/shared/hooks/query'
import { InlineTask, type InlineTaskItem } from '~/entities/task'

interface FormTaskProps {
  taskIds: number[]
}

const FormTasks = (props: FormTaskProps) => {
  const { taskIds } = props
  const queryClient = useQueryClient()

  const { data } = useQuery(
    taskV2.listQueryKey({ id__in: taskIds }),
    async () => {
      const response = await taskV2.list({ params: { id__in: taskIds } })
      return response.data.results
    },
    { enabled: taskIds.length > 0 },
    { error: 'Failed to fetch tasks' },
  )

  const updateTask = useMutation(
    ({ id, isComplete }: { id: number; isComplete: boolean }) =>
      taskV2.partialUpdate({ id }, { data: { is_complete: isComplete } }),
    {
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: taskV2.listQueryKey({ id__in: taskIds }) }),
    },
    { error: 'Failed to update task' },
  )

  const tasksById = new Map((data ?? []).map(t => [t.id, t]))
  const tasks = taskIds
    .map(id => tasksById.get(id))
    .filter((task): task is InlineTaskItem => task !== undefined)

  return (
    <Box>
      {tasks.map(task => (
        <InlineTask
          key={task.id}
          task={task}
          onChecked={async (isComplete: boolean) => {
            await updateTask.mutateAsync({ id: task.id, isComplete })
          }}
        />
      ))}
    </Box>
  )
}

export default FormTasks
